module.exports = __webpack_public_path__ + "static/media/error-modal.646fa2e0.svg";